module.exports = __webpack_public_path__ + "static/media/header-en.3be9553a.jpg";